import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from '../../../../utils/TestIds';
import { Column } from '../../../Layout';
import { MobileRecordCard } from '../../../MobileRecordCard';
import { Typography } from '../../../Typography';
import styles from '../../tableCore/table.module.scss';
import { summaryCardRows } from '../summaryCardRows/summaryCardRows';
export function SummaryMobileRows(param) {
    let { summaryRows, testId } = param;
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    if (summaryRows.length === 0) return null;
    return /*#__PURE__*/ _jsx(MobileRecordCard, {
        className: styles.mobileSummary,
        rowClassName: styles.summaryCardRow,
        rows: summaryCardRows(summaryRows).map((summaryRow, index)=>({
                key: summaryRow.id,
                spaceBetween: true,
                dividerBefore: index === 0,
                testId: testIds.summaryCardRow(summaryRow.id),
                label: (labelClassName)=>/*#__PURE__*/ _jsxs(Column, {
                        gap: 2,
                        className: "".concat(labelClassName, " ").concat(styles.summaryCardLabel),
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                weight: summaryRow.weight,
                                children: summaryRow.label
                            }),
                            summaryRow.caption != null && /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph3",
                                skin: "secondary",
                                breakWords: true,
                                testId: testIds.summaryCardCaption(summaryRow.id),
                                children: summaryRow.caption
                            })
                        ]
                    }),
                value: (valueClassName)=>/*#__PURE__*/ _jsx("div", {
                        className: "".concat(valueClassName, " ").concat(styles.summaryCardValue),
                        children: /*#__PURE__*/ _jsx(Typography, {
                            weight: summaryRow.weight,
                            children: summaryRow.value
                        })
                    })
            })),
        testId: testIds.summaryCard()
    });
}
